// extracted by css-extract-rspack-plugin
export default {"memberItem":"memberItem-VfX2yY","itemInfo":"itemInfo-A2_JZS"};